/* ============================================================
   AURA THEME — global.js
   Vanilla JS, no dependencies. Each block is self-contained and
   guards for the elements it needs, so it is safe on any template.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function toggleMenu(open) {
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleMenu(true); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleMenu(false); });
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', item.classList.contains('is-open'));
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty-input').querySelector('input');
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
    var next = Math.max(min, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyChange, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    var nums = {
      d: el.querySelector('[data-cd-days]'),
      h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-mins]'),
      s: el.querySelector('[data-cd-secs]')
    };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      if (nums.d) nums.d.textContent = pad(Math.floor(s / 86400));
      if (nums.h) nums.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (nums.m) nums.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (nums.s) nums.s.textContent = pad(s % 60);
      if (diff <= 0 && el.dataset.hideWhenDone === 'true') {
        (el.closest('.shopify-section') || el).style.display = 'none';
      }
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Before / after sliders ---------- */
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var after = slider.querySelector('.ba-slider__after');
    var handle = slider.querySelector('.ba-slider__handle');
    if (!after || !handle) return;
    var dragging = false;
    function setPos(clientX) {
      var rect = slider.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }
    function start(e) { dragging = true; setPos(e.touches ? e.touches[0].clientX : e.clientX); }
    function move(e) { if (dragging) setPos(e.touches ? e.touches[0].clientX : e.clientX); }
    function end() { dragging = false; }
    slider.addEventListener('mousedown', start);
    slider.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
  });

  /* ---------- Product gallery (media slides) ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var idx = thumb.dataset.galleryThumb;
    gallery.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
      var active = s.dataset.gallerySlide === idx;
      s.classList.toggle('is-active', active);
      var video = s.querySelector('video');
      if (video && !active) video.pause();
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('[data-variants-json]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var selects = root.querySelectorAll('[data-option-select]');
    if (!selects.length) return;
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        var idInput = root.querySelector('input[name="id"]');
        var priceEl = root.querySelector('[data-price]');
        var compareEl = root.querySelector('[data-compare-price]');
        var addBtns = root.querySelectorAll('[data-add-to-cart]');
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.innerHTML = match.price_formatted;
          if (compareEl) {
            compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
            if (match.compare_formatted) compareEl.innerHTML = match.compare_formatted;
          }
          addBtns.forEach(function (b) {
            b.disabled = !match.available;
            b.textContent = match.available ? (b.dataset.labelAdd || 'Add to cart') : (b.dataset.labelSoldOut || 'Sold out');
          });
        } else {
          addBtns.forEach(function (b) {
            b.disabled = true;
            b.textContent = b.dataset.labelUnavailable || 'Unavailable';
          });
        }
      });
    });
  });

  /* ---------- Bundle tiers (set quantity) ---------- */
  document.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-bundle-qty]');
    if (!tier) return;
    var root = tier.closest('[data-product-form]') || document;
    var qty = root.querySelector('form input[name="quantity"]');
    if (qty) {
      qty.value = tier.dataset.bundleQty;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
    (tier.closest('.bundle-tiers') || root).querySelectorAll('[data-bundle-qty]').forEach(function (t) {
      t.classList.toggle('is-active', t === tier);
    });
  });

  /* ---------- Delivery estimate ---------- */
  document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
    var min = parseInt(el.dataset.minDays, 10) || 5;
    var max = parseInt(el.dataset.maxDays, 10) || 12;
    var opts = { month: 'short', day: 'numeric' };
    var from = new Date(Date.now() + min * 864e5).toLocaleDateString('en', opts);
    var to = new Date(Date.now() + max * 864e5).toLocaleDateString('en', opts);
    var target = el.querySelector('[data-delivery-dates]');
    if (target) target.textContent = from + ' \u2013 ' + to;
  });

  /* ---------- Sticky add-to-cart ---------- */
  document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
    var anchorSel = bar.dataset.watch;
    var anchor = anchorSel ? document.querySelector(anchorSel) : null;
    if (!anchor || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-sticky-atc');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  });

  /* ---------- Cart line quantity / remove ---------- */
  function cartChange(line, quantity) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { window.location.reload(); });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) cartChange(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (btn) { e.preventDefault(); cartChange(parseInt(btn.dataset.line, 10), 0); }
  });
})();
